import { render, staticRenderFns } from "./forensics.vue?vue&type=template&id=d8ca6ec0&scoped=true"
import script from "./forensics.vue?vue&type=script&lang=js"
export * from "./forensics.vue?vue&type=script&lang=js"
import style0 from "./forensics.vue?vue&type=style&index=0&id=d8ca6ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ca6ec0",
  null
  
)

export default component.exports